import { useQuery } from "react-query";
import { getUserPermissionPerField } from "../../../../../actions/Utilities/ModuleManagement";

export const useGetUserPermissionPerField = (userId) => {
  return useQuery(["RolePermissionFields", userId], () => getUserPermissionPerField(userId));
};
